import { render, staticRenderFns } from "./ShareFiles.vue?vue&type=template&id=52aa41e0&scoped=true&"
import script from "./ShareFiles.vue?vue&type=script&lang=ts&"
export * from "./ShareFiles.vue?vue&type=script&lang=ts&"
import style0 from "./ShareFiles.vue?vue&type=style&index=0&id=52aa41e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa41e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow,VSpacer})
